// Imports
import PropTypes from 'prop-types'
import API from '../../../utils/http/api'
import intercom from '../../../utils/intercom/intercomUtils'

// Actions
const REQUEST = "steppingblocks/userProfile/REQUEST"
const SUCCESS = "steppingblocks/userProfile/SUCCESS"
const FAILURE = "steppingblocks/userProfile/FAILURE"

// Reducer
const initialState = {
  error: null,
  requestEnded: false,
  requestStarted: false,
}

export default (_state = initialState, action) => {
  const {type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestEnded: false,
        requestStarted: true,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        requestStarted: true,
      }
    case FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
        requestStarted: true,
      }
    default:
      return _state
  }
}


// Action Performers
export const performRetrieveUserProfile = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get('/users/profile')
    dispatch({ type: SUCCESS, payload: data})
    return data.user
  } catch (error) {
    dispatch({ type:FAILURE, payload: { error: error.message }})
    return error
  }
}

export const performUpdateUserProfile = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.patch('/users/profile', params)
    dispatch({ type: SUCCESS, payload: data})

    // Send updated user data to intercom
    const {user} = data
    intercom.intercomUpdate({
      user_id: user._id,
      email: user.email,
      createdAt: user.createdAt,
      updatedAt: user.updatedAt,
      insToken: user.insToken,
      stripe_needs_updated_payment: user.stripe_needs_updated_payment,
      stripe_plan_id_before_cancellation: user.stripe_plan_id_before_cancellation,
      ...user.info,
      ...user.profile,
      interests: user.interests.join(', '),
      lastLogin: user.lastLogin,
      accessAllowed: user.accessAllowed,
      isSystemAdministrator: user.isSystemAdministrator,
    })
    return data
  }
  catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message }})
    return error
  }
}

export const performUpdateProfilePicture = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.post('/users/profile_picture', params)
    dispatch({ type: SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message }})
    throw new Error(error.message)
  }
}

export const performCancelSubscription = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get('/users/profile')
    dispatch({ type: SUCCESS, payload: data })
    return data.user
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw new Error(error.message)
  }
}


// PropTypes
export const userProfilePropTypes = PropTypes.shape({
  error: PropTypes.string,
  requestEnded: PropTypes.bool.isRequired,
  requestStarted: PropTypes.bool.isRequired,
})

// Fixtures

export const userProfileTestData = {
  error: null,
  requestEnded: false,
  requestStarted: false,
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/userProfileDuck.js